import HostedProWorkflow from '/src/_includes/graphql/payment-methods/hosted-pro-workflow.md';
import HostedProAttributes from '/src/_includes/graphql/payment-methods/hosted-pro-attributes.md';
import * as React from 'react';
export default {
  HostedProWorkflow,
  HostedProAttributes,
  React
};